import { render, staticRenderFns } from "./MarketStatistics.vue?vue&type=template&id=4752fdca"
import script from "./MarketStatistics.vue?vue&type=script&lang=js"
export * from "./MarketStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FauxTabs: require('/vercel/path0/components/FauxTabs.vue').default,DfmgiStatistics: require('/vercel/path0/components/datablocks/Dfmgi-Statistics.vue').default})
